// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --table-border-color: #e2e2e2;
  --table-th-bgcolor: #f3f3f3;
  --table-th-highlight: #eee;
  --table-even-row-bgColor: #f9f9f9;
  --table-property-row-bgColor: #f3f3f3;
  --table-active-highlight-header-bgColor: #d0ebff;
  --table-active-highlight-header-borderColor: #b3d9f4;
  --table-active-highlight-header-txtColor: #1e5c8a;
  --table-active-highlight-td-bgColor: #f0f9ff;
  --table-active-highlight-td-borderColor: #b3d9f4;
  --table-active-highlight-even-td-bgColor: #e5f4ff;
  --table-active-highlight-even-td-borderColor: #b3d9f4;
  --table-active-highlight-property-td-bgColor: #deedf8;
  --table-active-highlight-property-td-borderColor: #add2ec;

  --dataTableCell-firstSelected: #1e5c8a;
  --dataTableCell-selected-borderColor: #b3d9f4;
  --dataTableCell-selected-bgColor: #f0f9ff;
  --dataTableCell-selected-bgColor-even: #e5f4ff;

  --dataTableCell-error-borderColor: #f44336;
  --dataTableCell-error-bgColor: #feeceb;
  --dataTableCell-error-bgColor-even: #fedada;

  --dataTableCell-warning-borderColor: #ff9800;
  --dataTableCell-warning-bgColor: #fff2dc;
  --dataTableCell-warning-bgColor-even: #fce6c8;

  --dataTableCell-success-borderColor: #008000;
  --dataTableCell-success-bgColor: #e6ffe6;
  --dataTableCell-success-bgColor-even: #d9f5d9;

  --dataTableCell-disabled-color: #828282;
  --dataTableCell-disabled-borderColor: #bfbfbf;
  --dataTableCell-disabled-bgColor: #e0e0e0;
  --dataTableCell-disabled-bgColor-even: #d1d1d1;

  --clvn-blue-50: hsl(214, 78%, 98%);
  --clvn-blue-100: hsl(210, 29%, 97%);
  --clvn-blue-150: hsl(201, 78%, 96%);
  --clvn-blue-200: hsl(198, 23%, 83%);
  --clvn-blue-300: hsl(153, 11%, 84%);
  --clvn-blue-400: hsl(197, 18%, 55%);
  --clvn-blue-500: hsl(215, 16%, 47%);
  --clvn-blue-600: hsl(194, 20%, 39%);
  --clvn-blue-700: hsl(194, 30%, 27%);
  --clvn-blue-800: hsl(194, 44%, 20%);
  --clvn-blue-900: hsl(193, 49%, 9%);
  --clvn-error: hsl(4, 88%, 37%);
  --clvn-primary: hsl(206, 100%, 50%);
  --clvn-green-100: hsl(150, 60%, 96%);
  --clvn-green-200: hsl(154, 56%, 92%);
  --clvn-green-300: hsl(154, 57%, 84%);
  --clvn-green-400: hsl(153, 58%, 76%);
  --clvn-green-500: hsl(153, 57%, 60%);
  --clvn-green-600: hsl(153, 40%, 47%);
  --clvn-green-700: hsl(154, 39%, 33%);
  --clvn-green-800: hsl(154, 49%, 18%);
  --clvn-green-900: hsl(155, 40%, 6%);
  --clvn-red-50: hsl(3, 90%, 96%);
  --clvn-red-100: hsl(3, 47%, 82%);
  --clvn-red-200: hsl(357, 94%, 74%);
  --clvn-red-300: hsl(4, 88%, 37%);
  --clvn-red-400: hsl(4, 59%, 31%);
  --clvn-red-500: hsl(4, 63%, 24%);
  --clvn-white-100: hsl(210, 29%, 97%);

  --clvn-alice-blue-50: #f0f9ff;
  --clvn-alice-blue-100: #d4eeff;
  --clvn-alice-blue-200: #9cd7ff;
  --clvn-alice-blue-300: #64c1ff;
  --clvn-alice-blue-400: #2caaff;
  --clvn-alice-blue-500: #0092f3;
  --clvn-alice-blue-600: #0070ba;
  --clvn-alice-blue-700: #004e82;
  --clvn-alice-blue-800: #002d4a;
  --clvn-alice-blue-900: #000b12;
  --clvn-alice-blue-950: #000000;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-text-fill-color: inherit !important;
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}

.MuiTab-wrapper {
  align-items: flex-start !important   ;
}

.MuiOutlinedInput-notchedOutline {
  border-color: #4a666e !important;
}

input:disabled + .MuiOutlinedInput-notchedOutline {
  border-color: #bfbfbf !important;
}

.MuiInputBase-root.Mui-disabled {
  pointer-events: none !important;
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #4a666e !important;
  border-width: 2px;
}

.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #4a666e !important;
}

.MuiSpeedDial-directionLeft .MuiSpeedDial-actions {
  padding-right: 34px !important;
}

.MuiSpeedDialAction-fab {
  margin: 2px !important;
}
.first-speed-dial:hover {
  z-index: 1049;
}

.first-speed-dial:hover {
  z-index: 1051;
}

.text-danger {
  color: #ff0000 !important;
}

.text-success {
  color: #01a166 !important;
}

.material-icons {
  vertical-align: middle;
}

/* overrides from Girona */

/*TODO: Replace 14px with 16px to correct tailwind*/
html {
  font-size: 14px;
}

body {
  overflow: hidden;
}

.delete-modal .md-dialog-title {
  background-color: #ff0000;
  color: white;
  padding-bottom: 20px;
}

@media (max-width: 960px) {
  .md-toolbar,
  .md-toolbar-row {
    min-height: 64px !important;
  }
}

.md-menu-content.md-select-menu {
  width: auto !important;
  width: initial !important;
  max-width: 100% !important;
  min-width: 280px;
}

.md-dialog {
  z-index: 15 !important;
  -webkit-font-smoothing: antialiased;
}

.md-dialog-overlay {
  z-index: 14 !important;
}

.md-menu-content {
  z-index: 16 !important;
}

.md-tabs-navigation {
  background-color: transparent !important;
}

.md-tabs-content {
  background-color: transparent !important;
}

.text-success {
  color: \$brand-success !important;
}

.text-danger {
  color: \$brand-danger !important;
}

.md-steppers-navigation {
  background-color: white;
}

.md-button {
  letter-spacing: 1px !important;
  font-weight: 600 !important;
}

.md-empty-state-container {
  overflow: hidden;
  max-width: 100%;
}

.md-empty-state-container p {
  word-break: break-word;
  display: inline-block;
  white-space: normal;
  max-width: 100%;
}

.alert {
  background-color: #f0f0f0;
  padding: 10px;
  border-left: 20px solid #6cdaac;
  margin: 15px 0;
}

.alert.alert-success {
  border-left: 20px solid #01a166;
}

.alert.alert-danger {
  border-left: 20px solid #ff0000;
}

.alert.alert-info {
  border-left: 20px solid blue;
}

.multi-select {
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 10px 10px 10px #ddd;
  padding: 5px;
  max-height: 300px;
  overflow: scroll;
}

.multi-select > div > div {
  margin-bottom: 5px;
}

input:disabled {
  -webkit-text-fill-color: gray !important;
}

.handsontableInputHolder.react .handsontableInput {
  max-width: 0px !important;
  height: 0px !important;
}

.react-dropdown-tree-select .disabled .node-label {
  color: black !important;
  cursor: initial !important;
}

.react-dropdown-tree-select .disabled input {
  display: none;
}

.react-dropdown-tree-select .disabled i {
  cursor: pointer !important;
}

.mdl-demo .dropdown {
  width: 100%;
  background-color: white;
}

.mdl-demo .dropdown-content {
  max-height: 350px;
  overflow: scroll;
}

.mdl-demo .dropdown .dropdown-trigger {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #25515b !important;
}

.react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.top:after {
  display: none !important;
}

.react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.bottom:after {
  display: none !important;
}

.mdl-demo .dropdown-trigger > span:after {
  font-size: 12px;
  color: #555;
}

.mdl-demo .toggle {
  font: normal normal normal 18px/1 'Material Icons';
  color: #555;
  white-space: pre;
  margin-right: -15px;
}

.mdl-demo .toggle.collapsed::after {
  cursor: pointer;
  content: '\\E5CF';
  vertical-align: sub;
}

.mdl-demo .toggle.expanded::after {
  cursor: pointer;
  content: '\\E5CE';
  vertical-align: sub;
}

.mdl-demo .node > label {
  margin-left: 20px;
}

/* checkbox styles */
.mdl-demo .checkbox-item {
  position: relative;
  width: 1rem;
  height: 1rem;
  margin-right: 0.75rem;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: 0;
  vertical-align: middle;
}

.mdl-demo .checkbox-item:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border: 2px solid #aaa;
  transition: all 0.3s ease-in-out;
}

.mdl-demo .checkbox-item:checked:before {
  height: 50%;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  border-top-style: none;
  border-right-style: none;
  border-color: #2196f3;
}

.vueTemplatesView .vueCreateUpdateTemplatesView .md-empty-state-container i {
  font-size: 75px !important;
  height: 75px;
  padding: 0;
}

.vueTemplatesView .md-empty-state-container strong {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}

.vueTemplatesView .add-section-holder .md-empty-state-container p {
  font-size: 13px;
}

.vueTemplatesView .add-parameter .md-empty-state-container p {
  font-size: 13px;
}

.vueTemplatesView .md-rounded .md-empty-state-container p {
  font-size: 13px;
}

.md-theme-default :not(input):not(textarea)::selection {
}

.read-grid-cell.header div {
  flex: 1;
  text-align: right;
}

.clickable {
  cursor: pointer;
}

.ReactVirtualized__Grid {
  outline: none;
}

.react-dropdown-tree-select .dropdown .dropdown-content {
  width: 100%;
}

.MuiSnackbarContent-root {
  display: 'flex';
}

.MuiSnackbarContent-message {
  flex: 1;
}

.MuiSnackbarContent-action {
  flex-shrink: 1;
}

.MuiTableSortLabel-root {
  height: 50px;
}

#admin-menu .MuiAccordion-root {
  box-shadow: none;
  border: none;
}
#admin-menu .MuiAccordion-root:before {
  display: none;
}

#admin-menu .MuiAccordionSummary-root {
  padding-left: 0;
}

#admin-menu .MuiAccordionDetails-root {
  padding: 0;
}

#admin-menu .MuiAccordion-root.Mui-expanded {
  margin: 0;
}

.MuiTab-wrapper {
  width: 100%;
  display: inline-flex;
  align-items: center;
  flex-direction: row !important;
  justify-content: flex-start !important;
}

.MuiTab-labelIcon {
  min-height: 48px !important;
  padding-top: 9px;
}

.admin-menu-portal .MuiStepLabel-labelContainer {
  opacity: 1;
  white-space: nowrap;
  transition: all 200ms ease-out;
}

.admin-menu-portal.closed .MuiStepLabel-labelContainer {
  opacity: 0;
  white-space: nowrap;
  transition: all 200ms ease-out;
  transition-delay: 100ms;
}

/*
  Tooltip CSS
  ===========
  The following CSS is a basic tooltip style.
  It is designed to be used with the data-tooltip attribute.
  The tooltip can be positioned at the top, right, bottom or left of the element.
  The tooltip arrow is animated and slides down when the tooltip becomes visible.
  IMPORTANT: Parent element must have a relative position.
*/
[data-tooltip] {
  --arrow-size: 5px;
  --clvn-tooltip-bg-color: var(--clvn-blue-800);
  font-size: 11px;
}

/* Positioning and visibility settings of the tooltip */
[data-tooltip]:before,
[data-tooltip]:after {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  left: 50%;
  bottom: calc(100% + var(--arrow-size));
  pointer-events: none;
  transition: 0.2s;
  will-change: transform;
  z-index: 999;
}

/* The actual tooltip with a dynamic width */
[data-tooltip]:before {
  content: attr(data-tooltip);
  padding: 10px 18px;
  min-width: 50px;
  max-width: 300px;
  width: max-content;
  width: -moz-max-content;
  border-radius: 6px;
  font-size: 11px;
  background-color: var(--clvn-tooltip-bg-color);
  background-image: linear-gradient(
    30deg,
    rgba(59, 72, 80, 1),
    rgba(59, 68, 75, 1),
    rgba(60, 82, 88, 1)
  );
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.2);
  color: #fff;
  text-align: center;
  white-space: pre-wrap;
  transform: translate(-50%, calc(0px - var(--arrow-size))) scale(0.5);
  word-break: break-word;
}

/* Tooltip arrow */
[data-tooltip]:after {
  content: '';
  border-style: solid;
  border-width: var(--arrow-size) var(--arrow-size) 0px var(--arrow-size); /* CSS triangle */
  border-color: var(--clvn-tooltip-bg-color) transparent transparent transparent;
  transition-duration: 0s; /* If the mouse leaves the element, 
                              the transition effects for the 
                              tooltip arrow are "turned off" */
  transform-origin: top; /* Orientation setting for the
                              slide-down effect */
  transform: translateX(-50%) scaleY(0);
}

/* Tooltip becomes visible at hover */
[data-tooltip]:hover:before,
[data-tooltip]:hover:after {
  visibility: visible;
  opacity: 1;
}
/* Scales from 0.5 to 1 -> grow effect */
[data-tooltip]:hover:before {
  transition-delay: 0.2s;
  transform: translate(-50%, calc(1px - var(--arrow-size))) scale(1);
}
/* 
  Arrow slide down effect only on mouseenter (NOT on mouseleave)
*/
[data-tooltip]:hover:after {
  transition-delay: 0.3s; /* Starting after the grow effect */
  transition-duration: 0.2s;
  transform: translateX(-50%) scaleY(1);
}

/* LEFT */
/* Tooltip + arrow */
[data-tooltip-dir='left']:before,
[data-tooltip-dir='left']:after {
  left: auto;
  right: calc(100% + var(--arrow-size));
  bottom: 50%;
}

/* Tooltip */
[data-tooltip-dir='left']:before {
  transform: translate(calc(0px - var(--arrow-size)), 50%) scale(0.5);
}
[data-tooltip-dir='left']:hover:before {
  transform: translate(calc(0px - var(--arrow-size)), 50%) scale(1);
}

/* Arrow */
[data-tooltip-dir='left']:after {
  border-width: var(--arrow-size) 0px var(--arrow-size) var(--arrow-size);
  border-color: transparent transparent transparent var(--clvn-tooltip-bg-color);
  transform-origin: left;
  transform: translateY(50%) scaleX(0);
}
[data-tooltip-dir='left']:hover:after {
  transform: translateY(50%) scaleX(1);
}

/* RIGHT */
[data-tooltip-dir='right']:before,
[data-tooltip-dir='right']:after {
  left: calc(100% + var(--arrow-size));
  bottom: 50%;
}

[data-tooltip-dir='right']:before {
  transform: translate(var(--arrow-size), 50%) scale(0.5);
}
[data-tooltip-dir='right']:hover:before {
  transform: translate(var(--arrow-size), 50%) scale(1);
}

[data-tooltip-dir='right']:after {
  border-width: var(--arrow-size) var(--arrow-size) var(--arrow-size) 0px;
  border-color: transparent var(--clvn-tooltip-bg-color) transparent transparent;
  transform-origin: right;
  transform: translateY(50%) scaleX(0);
}
[data-tooltip-dir='right']:hover:after {
  transform: translateY(50%) scaleX(1);
}

/* BOTTOM */
[data-tooltip-dir='bottom']:before,
[data-tooltip-dir='bottom']:after {
  top: calc(100% + var(--arrow-size));
  bottom: auto;
}

[data-tooltip-dir='bottom']:before {
  transform: translate(-50%, var(--arrow-size)) scale(0.5);
}
[data-tooltip-dir='bottom']:hover:before {
  transform: translate(-50%, var(--arrow-size)) scale(1);
}

[data-tooltip-dir='bottom']:after {
  border-width: 0px var(--arrow-size) var(--arrow-size) var(--arrow-size);
  border-color: transparent transparent var(--clvn-tooltip-bg-color) transparent;
  transform-origin: bottom;
}

/* set default font family for tailwind classes 
  exclude material-icons class so we don't override the icon font
*/
*[class^='text-']:not([class*='material-']),
*[class*=' text-']:not([class*='material-']) {
  font-family: Inter, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./overrides.global.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,iCAAiC;EACjC,qCAAqC;EACrC,gDAAgD;EAChD,oDAAoD;EACpD,iDAAiD;EACjD,4CAA4C;EAC5C,gDAAgD;EAChD,iDAAiD;EACjD,qDAAqD;EACrD,qDAAqD;EACrD,yDAAyD;;EAEzD,sCAAsC;EACtC,6CAA6C;EAC7C,yCAAyC;EACzC,8CAA8C;;EAE9C,0CAA0C;EAC1C,sCAAsC;EACtC,2CAA2C;;EAE3C,4CAA4C;EAC5C,wCAAwC;EACxC,6CAA6C;;EAE7C,4CAA4C;EAC5C,wCAAwC;EACxC,6CAA6C;;EAE7C,uCAAuC;EACvC,6CAA6C;EAC7C,yCAAyC;EACzC,8CAA8C;;EAE9C,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;;EAEpC,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;;;;EAIE,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;;AAE1B,mDAAmD;AACnD;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kDAAkD;EAClD,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;AACA;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;;;;;;;CAQC;AACD;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA,uDAAuD;AACvD;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C;;;;;GAKC;EACD,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,oEAAoE;EACpE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,mBAAmB;EACnB,uEAAuE,EAAE,iBAAiB;EAC1F,8EAA8E;EAC9E,uBAAuB,EAAE;;8DAEmC;EAC5D,qBAAqB,EAAE;iDACwB;EAC/C,qCAAqC;AACvC;;AAEA,qCAAqC;AACrC;;EAEE,mBAAmB;EACnB,UAAU;AACZ;AACA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,kEAAkE;AACpE;AACA;;CAEC;AACD;EACE,sBAAsB,EAAE,mCAAmC;EAC3D,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,SAAS;AACT,oBAAoB;AACpB;;EAEE,UAAU;EACV,qCAAqC;EACrC,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,mEAAmE;AACrE;AACA;EACE,iEAAiE;AACnE;;AAEA,UAAU;AACV;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA,UAAU;AACV;;EAEE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,uDAAuD;AACzD;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA,WAAW;AACX;;EAEE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,wDAAwD;AAC1D;AACA;EACE,sDAAsD;AACxD;;AAEA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,wBAAwB;AAC1B;;AAEA;;CAEC;AACD;;EAEE,8BAA8B;AAChC","sourcesContent":[":root {\n  --table-border-color: #e2e2e2;\n  --table-th-bgcolor: #f3f3f3;\n  --table-th-highlight: #eee;\n  --table-even-row-bgColor: #f9f9f9;\n  --table-property-row-bgColor: #f3f3f3;\n  --table-active-highlight-header-bgColor: #d0ebff;\n  --table-active-highlight-header-borderColor: #b3d9f4;\n  --table-active-highlight-header-txtColor: #1e5c8a;\n  --table-active-highlight-td-bgColor: #f0f9ff;\n  --table-active-highlight-td-borderColor: #b3d9f4;\n  --table-active-highlight-even-td-bgColor: #e5f4ff;\n  --table-active-highlight-even-td-borderColor: #b3d9f4;\n  --table-active-highlight-property-td-bgColor: #deedf8;\n  --table-active-highlight-property-td-borderColor: #add2ec;\n\n  --dataTableCell-firstSelected: #1e5c8a;\n  --dataTableCell-selected-borderColor: #b3d9f4;\n  --dataTableCell-selected-bgColor: #f0f9ff;\n  --dataTableCell-selected-bgColor-even: #e5f4ff;\n\n  --dataTableCell-error-borderColor: #f44336;\n  --dataTableCell-error-bgColor: #feeceb;\n  --dataTableCell-error-bgColor-even: #fedada;\n\n  --dataTableCell-warning-borderColor: #ff9800;\n  --dataTableCell-warning-bgColor: #fff2dc;\n  --dataTableCell-warning-bgColor-even: #fce6c8;\n\n  --dataTableCell-success-borderColor: #008000;\n  --dataTableCell-success-bgColor: #e6ffe6;\n  --dataTableCell-success-bgColor-even: #d9f5d9;\n\n  --dataTableCell-disabled-color: #828282;\n  --dataTableCell-disabled-borderColor: #bfbfbf;\n  --dataTableCell-disabled-bgColor: #e0e0e0;\n  --dataTableCell-disabled-bgColor-even: #d1d1d1;\n\n  --clvn-blue-50: hsl(214, 78%, 98%);\n  --clvn-blue-100: hsl(210, 29%, 97%);\n  --clvn-blue-150: hsl(201, 78%, 96%);\n  --clvn-blue-200: hsl(198, 23%, 83%);\n  --clvn-blue-300: hsl(153, 11%, 84%);\n  --clvn-blue-400: hsl(197, 18%, 55%);\n  --clvn-blue-500: hsl(215, 16%, 47%);\n  --clvn-blue-600: hsl(194, 20%, 39%);\n  --clvn-blue-700: hsl(194, 30%, 27%);\n  --clvn-blue-800: hsl(194, 44%, 20%);\n  --clvn-blue-900: hsl(193, 49%, 9%);\n  --clvn-error: hsl(4, 88%, 37%);\n  --clvn-primary: hsl(206, 100%, 50%);\n  --clvn-green-100: hsl(150, 60%, 96%);\n  --clvn-green-200: hsl(154, 56%, 92%);\n  --clvn-green-300: hsl(154, 57%, 84%);\n  --clvn-green-400: hsl(153, 58%, 76%);\n  --clvn-green-500: hsl(153, 57%, 60%);\n  --clvn-green-600: hsl(153, 40%, 47%);\n  --clvn-green-700: hsl(154, 39%, 33%);\n  --clvn-green-800: hsl(154, 49%, 18%);\n  --clvn-green-900: hsl(155, 40%, 6%);\n  --clvn-red-50: hsl(3, 90%, 96%);\n  --clvn-red-100: hsl(3, 47%, 82%);\n  --clvn-red-200: hsl(357, 94%, 74%);\n  --clvn-red-300: hsl(4, 88%, 37%);\n  --clvn-red-400: hsl(4, 59%, 31%);\n  --clvn-red-500: hsl(4, 63%, 24%);\n  --clvn-white-100: hsl(210, 29%, 97%);\n\n  --clvn-alice-blue-50: #f0f9ff;\n  --clvn-alice-blue-100: #d4eeff;\n  --clvn-alice-blue-200: #9cd7ff;\n  --clvn-alice-blue-300: #64c1ff;\n  --clvn-alice-blue-400: #2caaff;\n  --clvn-alice-blue-500: #0092f3;\n  --clvn-alice-blue-600: #0070ba;\n  --clvn-alice-blue-700: #004e82;\n  --clvn-alice-blue-800: #002d4a;\n  --clvn-alice-blue-900: #000b12;\n  --clvn-alice-blue-950: #000000;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-text-fill-color: inherit !important;\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n\n.MuiTab-wrapper {\n  align-items: flex-start !important   ;\n}\n\n.MuiOutlinedInput-notchedOutline {\n  border-color: #4a666e !important;\n}\n\ninput:disabled + .MuiOutlinedInput-notchedOutline {\n  border-color: #bfbfbf !important;\n}\n\n.MuiInputBase-root.Mui-disabled {\n  pointer-events: none !important;\n}\n\n.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #4a666e !important;\n  border-width: 2px;\n}\n\n.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #4a666e !important;\n}\n\n.MuiSpeedDial-directionLeft .MuiSpeedDial-actions {\n  padding-right: 34px !important;\n}\n\n.MuiSpeedDialAction-fab {\n  margin: 2px !important;\n}\n.first-speed-dial:hover {\n  z-index: 1049;\n}\n\n.first-speed-dial:hover {\n  z-index: 1051;\n}\n\n.text-danger {\n  color: #ff0000 !important;\n}\n\n.text-success {\n  color: #01a166 !important;\n}\n\n.material-icons {\n  vertical-align: middle;\n}\n\n/* overrides from Girona */\n\n/*TODO: Replace 14px with 16px to correct tailwind*/\nhtml {\n  font-size: 14px;\n}\n\nbody {\n  overflow: hidden;\n}\n\n.delete-modal .md-dialog-title {\n  background-color: #ff0000;\n  color: white;\n  padding-bottom: 20px;\n}\n\n@media (max-width: 960px) {\n  .md-toolbar,\n  .md-toolbar-row {\n    min-height: 64px !important;\n  }\n}\n\n.md-menu-content.md-select-menu {\n  width: auto !important;\n  width: initial !important;\n  max-width: 100% !important;\n  min-width: 280px;\n}\n\n.md-dialog {\n  z-index: 15 !important;\n  -webkit-font-smoothing: antialiased;\n}\n\n.md-dialog-overlay {\n  z-index: 14 !important;\n}\n\n.md-menu-content {\n  z-index: 16 !important;\n}\n\n.md-tabs-navigation {\n  background-color: transparent !important;\n}\n\n.md-tabs-content {\n  background-color: transparent !important;\n}\n\n.text-success {\n  color: $brand-success !important;\n}\n\n.text-danger {\n  color: $brand-danger !important;\n}\n\n.md-steppers-navigation {\n  background-color: white;\n}\n\n.md-button {\n  letter-spacing: 1px !important;\n  font-weight: 600 !important;\n}\n\n.md-empty-state-container {\n  overflow: hidden;\n  max-width: 100%;\n}\n\n.md-empty-state-container p {\n  word-break: break-word;\n  display: inline-block;\n  white-space: normal;\n  max-width: 100%;\n}\n\n.alert {\n  background-color: #f0f0f0;\n  padding: 10px;\n  border-left: 20px solid #6cdaac;\n  margin: 15px 0;\n}\n\n.alert.alert-success {\n  border-left: 20px solid #01a166;\n}\n\n.alert.alert-danger {\n  border-left: 20px solid #ff0000;\n}\n\n.alert.alert-info {\n  border-left: 20px solid blue;\n}\n\n.multi-select {\n  background-color: white;\n  border: 1px solid #ccc;\n  box-shadow: 10px 10px 10px #ddd;\n  padding: 5px;\n  max-height: 300px;\n  overflow: scroll;\n}\n\n.multi-select > div > div {\n  margin-bottom: 5px;\n}\n\ninput:disabled {\n  -webkit-text-fill-color: gray !important;\n}\n\n.handsontableInputHolder.react .handsontableInput {\n  max-width: 0px !important;\n  height: 0px !important;\n}\n\n.react-dropdown-tree-select .disabled .node-label {\n  color: black !important;\n  cursor: initial !important;\n}\n\n.react-dropdown-tree-select .disabled input {\n  display: none;\n}\n\n.react-dropdown-tree-select .disabled i {\n  cursor: pointer !important;\n}\n\n.mdl-demo .dropdown {\n  width: 100%;\n  background-color: white;\n}\n\n.mdl-demo .dropdown-content {\n  max-height: 350px;\n  overflow: scroll;\n}\n\n.mdl-demo .dropdown .dropdown-trigger {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #25515b !important;\n}\n\n.react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.top:after {\n  display: none !important;\n}\n\n.react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.bottom:after {\n  display: none !important;\n}\n\n.mdl-demo .dropdown-trigger > span:after {\n  font-size: 12px;\n  color: #555;\n}\n\n.mdl-demo .toggle {\n  font: normal normal normal 18px/1 'Material Icons';\n  color: #555;\n  white-space: pre;\n  margin-right: -15px;\n}\n\n.mdl-demo .toggle.collapsed::after {\n  cursor: pointer;\n  content: '\\E5CF';\n  vertical-align: sub;\n}\n\n.mdl-demo .toggle.expanded::after {\n  cursor: pointer;\n  content: '\\E5CE';\n  vertical-align: sub;\n}\n\n.mdl-demo .node > label {\n  margin-left: 20px;\n}\n\n/* checkbox styles */\n.mdl-demo .checkbox-item {\n  position: relative;\n  width: 1rem;\n  height: 1rem;\n  margin-right: 0.75rem;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  outline: 0;\n  vertical-align: middle;\n}\n\n.mdl-demo .checkbox-item:before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  border: 2px solid #aaa;\n  transition: all 0.3s ease-in-out;\n}\n\n.mdl-demo .checkbox-item:checked:before {\n  height: 50%;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  border-top-style: none;\n  border-right-style: none;\n  border-color: #2196f3;\n}\n\n.vueTemplatesView .vueCreateUpdateTemplatesView .md-empty-state-container i {\n  font-size: 75px !important;\n  height: 75px;\n  padding: 0;\n}\n\n.vueTemplatesView .md-empty-state-container strong {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.vueTemplatesView .add-section-holder .md-empty-state-container p {\n  font-size: 13px;\n}\n\n.vueTemplatesView .add-parameter .md-empty-state-container p {\n  font-size: 13px;\n}\n\n.vueTemplatesView .md-rounded .md-empty-state-container p {\n  font-size: 13px;\n}\n\n.md-theme-default :not(input):not(textarea)::selection {\n}\n\n.read-grid-cell.header div {\n  flex: 1;\n  text-align: right;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.ReactVirtualized__Grid {\n  outline: none;\n}\n\n.react-dropdown-tree-select .dropdown .dropdown-content {\n  width: 100%;\n}\n\n.MuiSnackbarContent-root {\n  display: 'flex';\n}\n\n.MuiSnackbarContent-message {\n  flex: 1;\n}\n\n.MuiSnackbarContent-action {\n  flex-shrink: 1;\n}\n\n.MuiTableSortLabel-root {\n  height: 50px;\n}\n\n#admin-menu .MuiAccordion-root {\n  box-shadow: none;\n  border: none;\n}\n#admin-menu .MuiAccordion-root:before {\n  display: none;\n}\n\n#admin-menu .MuiAccordionSummary-root {\n  padding-left: 0;\n}\n\n#admin-menu .MuiAccordionDetails-root {\n  padding: 0;\n}\n\n#admin-menu .MuiAccordion-root.Mui-expanded {\n  margin: 0;\n}\n\n.MuiTab-wrapper {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  flex-direction: row !important;\n  justify-content: flex-start !important;\n}\n\n.MuiTab-labelIcon {\n  min-height: 48px !important;\n  padding-top: 9px;\n}\n\n.admin-menu-portal .MuiStepLabel-labelContainer {\n  opacity: 1;\n  white-space: nowrap;\n  transition: all 200ms ease-out;\n}\n\n.admin-menu-portal.closed .MuiStepLabel-labelContainer {\n  opacity: 0;\n  white-space: nowrap;\n  transition: all 200ms ease-out;\n  transition-delay: 100ms;\n}\n\n/*\n  Tooltip CSS\n  ===========\n  The following CSS is a basic tooltip style.\n  It is designed to be used with the data-tooltip attribute.\n  The tooltip can be positioned at the top, right, bottom or left of the element.\n  The tooltip arrow is animated and slides down when the tooltip becomes visible.\n  IMPORTANT: Parent element must have a relative position.\n*/\n[data-tooltip] {\n  --arrow-size: 5px;\n  --clvn-tooltip-bg-color: var(--clvn-blue-800);\n  font-size: 11px;\n}\n\n/* Positioning and visibility settings of the tooltip */\n[data-tooltip]:before,\n[data-tooltip]:after {\n  position: absolute;\n  visibility: hidden;\n  opacity: 0;\n  left: 50%;\n  bottom: calc(100% + var(--arrow-size));\n  pointer-events: none;\n  transition: 0.2s;\n  will-change: transform;\n  z-index: 999;\n}\n\n/* The actual tooltip with a dynamic width */\n[data-tooltip]:before {\n  content: attr(data-tooltip);\n  padding: 10px 18px;\n  min-width: 50px;\n  max-width: 300px;\n  width: max-content;\n  width: -moz-max-content;\n  border-radius: 6px;\n  font-size: 11px;\n  background-color: var(--clvn-tooltip-bg-color);\n  background-image: linear-gradient(\n    30deg,\n    rgba(59, 72, 80, 1),\n    rgba(59, 68, 75, 1),\n    rgba(60, 82, 88, 1)\n  );\n  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.2);\n  color: #fff;\n  text-align: center;\n  white-space: pre-wrap;\n  transform: translate(-50%, calc(0px - var(--arrow-size))) scale(0.5);\n  word-break: break-word;\n}\n\n/* Tooltip arrow */\n[data-tooltip]:after {\n  content: '';\n  border-style: solid;\n  border-width: var(--arrow-size) var(--arrow-size) 0px var(--arrow-size); /* CSS triangle */\n  border-color: var(--clvn-tooltip-bg-color) transparent transparent transparent;\n  transition-duration: 0s; /* If the mouse leaves the element, \n                              the transition effects for the \n                              tooltip arrow are \"turned off\" */\n  transform-origin: top; /* Orientation setting for the\n                              slide-down effect */\n  transform: translateX(-50%) scaleY(0);\n}\n\n/* Tooltip becomes visible at hover */\n[data-tooltip]:hover:before,\n[data-tooltip]:hover:after {\n  visibility: visible;\n  opacity: 1;\n}\n/* Scales from 0.5 to 1 -> grow effect */\n[data-tooltip]:hover:before {\n  transition-delay: 0.2s;\n  transform: translate(-50%, calc(1px - var(--arrow-size))) scale(1);\n}\n/* \n  Arrow slide down effect only on mouseenter (NOT on mouseleave)\n*/\n[data-tooltip]:hover:after {\n  transition-delay: 0.3s; /* Starting after the grow effect */\n  transition-duration: 0.2s;\n  transform: translateX(-50%) scaleY(1);\n}\n\n/* LEFT */\n/* Tooltip + arrow */\n[data-tooltip-dir='left']:before,\n[data-tooltip-dir='left']:after {\n  left: auto;\n  right: calc(100% + var(--arrow-size));\n  bottom: 50%;\n}\n\n/* Tooltip */\n[data-tooltip-dir='left']:before {\n  transform: translate(calc(0px - var(--arrow-size)), 50%) scale(0.5);\n}\n[data-tooltip-dir='left']:hover:before {\n  transform: translate(calc(0px - var(--arrow-size)), 50%) scale(1);\n}\n\n/* Arrow */\n[data-tooltip-dir='left']:after {\n  border-width: var(--arrow-size) 0px var(--arrow-size) var(--arrow-size);\n  border-color: transparent transparent transparent var(--clvn-tooltip-bg-color);\n  transform-origin: left;\n  transform: translateY(50%) scaleX(0);\n}\n[data-tooltip-dir='left']:hover:after {\n  transform: translateY(50%) scaleX(1);\n}\n\n/* RIGHT */\n[data-tooltip-dir='right']:before,\n[data-tooltip-dir='right']:after {\n  left: calc(100% + var(--arrow-size));\n  bottom: 50%;\n}\n\n[data-tooltip-dir='right']:before {\n  transform: translate(var(--arrow-size), 50%) scale(0.5);\n}\n[data-tooltip-dir='right']:hover:before {\n  transform: translate(var(--arrow-size), 50%) scale(1);\n}\n\n[data-tooltip-dir='right']:after {\n  border-width: var(--arrow-size) var(--arrow-size) var(--arrow-size) 0px;\n  border-color: transparent var(--clvn-tooltip-bg-color) transparent transparent;\n  transform-origin: right;\n  transform: translateY(50%) scaleX(0);\n}\n[data-tooltip-dir='right']:hover:after {\n  transform: translateY(50%) scaleX(1);\n}\n\n/* BOTTOM */\n[data-tooltip-dir='bottom']:before,\n[data-tooltip-dir='bottom']:after {\n  top: calc(100% + var(--arrow-size));\n  bottom: auto;\n}\n\n[data-tooltip-dir='bottom']:before {\n  transform: translate(-50%, var(--arrow-size)) scale(0.5);\n}\n[data-tooltip-dir='bottom']:hover:before {\n  transform: translate(-50%, var(--arrow-size)) scale(1);\n}\n\n[data-tooltip-dir='bottom']:after {\n  border-width: 0px var(--arrow-size) var(--arrow-size) var(--arrow-size);\n  border-color: transparent transparent var(--clvn-tooltip-bg-color) transparent;\n  transform-origin: bottom;\n}\n\n/* set default font family for tailwind classes \n  exclude material-icons class so we don't override the icon font\n*/\n*[class^='text-']:not([class*='material-']),\n*[class*=' text-']:not([class*='material-']) {\n  font-family: Inter, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
